import React from 'react';

const Badge = ({ children, variant = 'yellow', className = '' }) => {
  const variants = {
    yellow: 'bg-lemon-yellow text-ink-navy border-ink-navy',
    blue: 'bg-sky-blue text-white border-ink-navy',
    outline: 'bg-white text-ink-navy border-ink-navy',
    success: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  };

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border-2 ${variants[variant]} ${className}`}>
      {children}
    </span>
  );
};

export default Badge;